module.exports = __webpack_public_path__ + "img/Lif-mobile-1.b2ea5f56.png";